import React from 'react';
import { Form, Switch, Select } from 'antd';
import {
  BellOutlined,
  GiftOutlined,
  MessageOutlined,
  MailOutlined
} from '@ant-design/icons';

const { Option } = Select;

const Section11Marketing = () => {
  return (
    <div className="section-container">
      <div className="section-header">
        <span className="section-badge">SECTION 11</span>
        <h3>Marketing & Communication Preferences</h3>
        <p className="section-description">
          Customize how you would like IBAS to communicate upcoming workshops, alumni discounts, and free masterclasses. You can change these preferences at any time.
        </p>
      </div>

      <div className="form-grid">
        <div className="preference-switches-list">
          <div className="pref-switch-card">
            <div className="pref-info">
              <div className="pref-icon-circle blue">
                <BellOutlined />
              </div>
              <div>
                <h4>Receive Course Updates & Lecture Schedules</h4>
                <p>Receive notifications regarding class timetable adjustments and lecture recordings.</p>
              </div>
            </div>
            <Form.Item name="receiveCourseUpdates" valuePropName="checked" initialValue={true} noStyle>
              <Switch />
            </Form.Item>
          </div>

          <div className="pref-switch-card">
            <div className="pref-info">
              <div className="pref-icon-circle green">
                <GiftOutlined />
              </div>
              <div>
                <h4>Receive Special Offers & Alumni Discounts</h4>
                <p>Exclusive early-bird pricing and scholarship opportunities on new programmes.</p>
              </div>
            </div>
            <Form.Item name="receiveSpecialOffers" valuePropName="checked" initialValue={true} noStyle>
              <Switch />
            </Form.Item>
          </div>

          <div className="pref-switch-card">
            <div className="pref-info">
              <div className="pref-icon-circle emerald">
                <MessageOutlined />
              </div>
              <div>
                <h4>Receive WhatsApp Notifications</h4>
                <p>Convenient instant alerts via official IBAS WhatsApp channels.</p>
              </div>
            </div>
            <Form.Item name="receiveWhatsappUpdates" valuePropName="checked" initialValue={true} noStyle>
              <Switch />
            </Form.Item>
          </div>

          <div className="pref-switch-card">
            <div className="pref-info">
              <div className="pref-icon-circle purple">
                <MailOutlined />
              </div>
              <div>
                <h4>Receive Email Bulletins & Newsletters</h4>
                <p>Monthly industry analysis, Excel/Power BI tips, and career articles.</p>
              </div>
            </div>
            <Form.Item name="receiveEmailUpdates" valuePropName="checked" initialValue={true} noStyle>
              <Switch />
            </Form.Item>
          </div>
        </div>

        <Form.Item
          label="Preferred Primary Communication Channel"
          name="preferredMarketingChannel"
          rules={[{ required: true, message: 'Please select your preferred channel' }]}
          initialValue="whatsapp"
          style={{ marginTop: 16 }}
        >
          <Select size="large">
            <Option value="whatsapp">WhatsApp Official Channel</Option>
            <Option value="email">Email Communications</Option>
            <Option value="sms">Mobile SMS</Option>
            <Option value="phone">Direct Phone Call</Option>
          </Select>
        </Form.Item>
      </div>
    </div>
  );
};

export default Section11Marketing;
